import React, {useEffect} from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import {Link} from "react-router-dom";
import {getOrganisationalStructure} from "../../../store/organisationalSlice";
import {useDispatch, useSelector} from "react-redux";

const Teachers = () => {

    const dispatch = useDispatch();


    const { organisationalStructure } = useSelector((state) => state.organisationalStructure);

    useEffect(() => {
        dispatch(getOrganisationalStructure());
    }, [dispatch]);

    return (
        <div className="mt-10 relative" style={{width: '100%'}}>
            <h2 className='font-semibold text-[24px]'>Instructors</h2>
            <Swiper
                spaceBetween={20}
                navigation={{
                    nextEl: ".swiper-next",
                    prevEl: ".swiper-prev",
                }}
                modules={[Navigation]}
                className="swiper-container"
                breakpoints={{
                    320: {slidesPerView: 2},
                    768: {slidesPerView: 4},
                    1024: {slidesPerView: 5},
                    1280: {slidesPerView: 6.4},
                }}
            >
                {organisationalStructure?.filter(item => item.status === "INSTRUCTOR")?.map((item, index) => (
                    <SwiperSlide
                        key={index}
                        className="flex flex-col justify-center items-center h-64 rounded-lg p-4"
                    >
                        <Link to={item.description} target={"_blank"} className='text-center'>
                            <img src={item.photo} alt={item.position}
                                 className="w-[124px] h-[124px] sm:w-[164px] sm:h-[164px] rounded-full object-cover m-auto mb-3"/>
                            <p className="text-[18px] sm:text-[22px] font-semibold">{item.full_name}</p>
                            <p className="text-[13px] text-gray-500 block sm:hidden">{item.location}</p>
                        </Link>
                    </SwiperSlide>
                ))}
            </Swiper>
            <div className="mt-8 flex justify-center items-center gap-6">
                <button
                    className={`swiper-prev swiper-button-disabled text-3xl text-[#0A1F44] hover:text-black transition`}>←
                </button>
                <span className="w-px h-6 bg-gray-500"></span>
                <button className={`swiper-next text-3xl text-[#0A1F44] hover:text-black transition`}>→</button>
            </div>
        </div>
    );
};

export default Teachers;
